import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { trigger, style, animate, transition, query, stagger, keyframes, state, group } from '@angular/animations';
import { CommonService } from "../common.service";
import { ApiService} from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";
import {StoreService} from '../store.service';

declare var $: any;

@Component({
  selector: 'app-case-practice-revolution-report',
  animations: [
    trigger('bestPathBoxAnimation', [
      state('hideBestPathBox', style({opacity: 0, transform: 'scale(0, 0)'})),
      state('showBestPathBox', style({opacity: 1, transform: 'scale(1, 1)'})),
      transition('hideBestPathBox => showBestPathBox', animate('200ms', keyframes([
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(1, 1)', opacity: 1})
        ]))
      ),
      transition('showBestPathBox => hideBestPathBox', animate('200ms', keyframes([
          style({opacity: 1}),
          style({opacity: 0})
        ]))
      )
    ]),
    trigger('analysisBoxAnimation', [
      state('hideAnalysisBox', style({opacity: 0, transform: 'translate(-100%)'})),
      state('showAnalysisBox', style({opacity: 1})),
      transition('hideAnalysisBox => showAnalysisBox', animate('200ms', keyframes([
          style({transform: 'matrix3d(0.08700000000000001,-0.09,0.50,0,0.09,0.01,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
                 opacity: 1, left: 0, top: '45%'}),
          style({transform: 'matrix3d(0.43065,-0.12,0.50,0,0.12,0.2475,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
                 opacity: 1, left: 0, top: '47%'}),
          style({transform: 'matrix3d(0.6525,-0.07,0.50,0,0.07,0.6,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
                 opacity: 1, left: 0, top: '49%'}),
          style({transform: 'matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,0,0,1) translate(0, -50%)',
                 opacity: 1, left: 0, top: '50%'})
          ])
        )
      ),
      transition('showAnalysisBox => hideAnalysisBox', animate('500ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0})
      ])))
    ]),
    trigger('starAnimation', [
      state('hideStar', style({opacity: 0})),
      state('showStar', style({opacity: 1})),
      transition('hideStar => showStar', [
        style({opacity: 1}),
        query('.starReport', style({opacity: 0})),
        query('.starReport5', animate('200ms', style({opacity: 1})), { optional: true }),
        query('.starReport4', animate('200ms', style({opacity: 1})), { optional: true }),
        query('.starReport3', animate('200ms', style({opacity: 1})), { optional: true }),
        query('.starReport2', animate('200ms', style({opacity: 1})), { optional: true }),
        query('.starReport1', animate('200ms', style({opacity: 1})), { optional: true })
      ])
    ])
  ],
  templateUrl: './case-practice-revolution-report.component.html',
  styleUrls: ['./case-practice-revolution-report.component.css',]

})
export class CasePracticeRevolutionReportComponent implements OnInit, AfterViewInit {

  currentName: any;
  currentTotal: any;
  currentDescription: any;
  currentAnalysis: any;

  practiceId: any;
  exerciseId: any;
  learningPathId: any;

  report: any;

  //报告等级KA对象：传递给等级组件
  reportKAData: any;
  // 是否显示等级组件：用于异步渲染判断
  isShowReportLv: boolean;
  //二级标识，用于判断接口返回正常不正常：正常显示组件，不正常隐藏组件
  targetShow: any;

  // chuanjie: any;
  learningPathMetaId: any;
  learningPath: any;
  learningTour: any;
  finished: boolean;
  practiceMetaId: number;
  analysisBoxShow: boolean;
  bestPathBoxShow: boolean;
  starShow: boolean;
  reportName: string;

  tutor: any;
  optimum: any;

  mode: number;
  lvCls: string;

  // 皮肤样式
  skinColor: string='Orange';


  starPicUrl: string;

  pathClickable: boolean;
  goToListClickedStatus: boolean;
  redoClickedStatus: boolean;
  assetsRoute: string = "../../assets";

  itemClickEnable:boolean = false;
  type :  string
  //配置信息
	abilityConfig:AbilityConfig;
  constructor(private commonService:CommonService,
              private apiService: ApiService,
              private route: ActivatedRoute,
              private router: Router,
              private storeService:StoreService) { }

  ngOnInit(){
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.abilityConfig = new AbilityConfig(this.apiService,this.commonService);
    let that = this;
    this.isShowReportLv = false;
    this.bestPathBoxShow = false;
    this.analysisBoxShow = false;
    this.starShow = false;
    this.pathClickable = true;
    this.goToListClickedStatus = false;
    this.redoClickedStatus = false;
    this.route.queryParams.subscribe(queryParams=>{
      this.type=queryParams['type']
    })
    this.route.params.subscribe(params => {
      this.practiceId = params['practiceId'];
      this.exerciseId = params['exerciseId'];
      this.learningPathId = params['learningPathId'];
      this.updateExerciseReports();

      this.apiService.ajax({
        'type':'get',
        'url': '/sr/learningtour',
      }).subscribe(result=>{
        this.learningTour = result;
      });

      // this.optimum = '<p class="excellentDemonstrationTitle flowerBorderBottom">优秀示范</p><p class="dialogBox">做完练习之后，你应该感受到变革的艰辛了。你的关键行为有没有满星呢？一起来看看一个优秀主管应该怎么做吧！</p><p class="changeTitle fontBlod">变革start，告诉团队小伙伴！</p><p>作为技术部的主管也是项目负责人，你收到变革消息后，准备在本周二上午10：00给项目组成员开个会。这时，拿出了笔记本，把开会要说明的重点写在了笔记本上。</p><div class="bg-lightOrange"><p class="fontOrange">「最佳选择」</p><p class="smLineHeight">1.受外来竞争影响，A、B、C大客户不断流失，一季度营业额下降10%。</p><p class="smLineHeight">2.拓宽产品类型，各部门抽调成员，成立新的项目组开发新产品。</p><p class="smLineHeight">3.被抽调员工的工作内容和优先级将发生变化。</p><p class="smLineHeight">4.若能率先开发上线，便可抢占先机，赢得市场。</p></div><p>会议开始了，你按照会前准备的重点，跟团队成员进行了阐述。大家反应各不相同。' +
      //   '下属在会议中清楚的知道了什么在变，为什么要变以及对组织的预期收益。在会议结束前，你给团队成员布置了任务。（任务：做调研报告  时间：下周三15：00前）</p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>这个场景中需要运用变革加速器一，说明了变革的内容、愿意及预期收益。主管会议上说的清楚，下属在会活就不会麻烦不断。</p></div><p>如果你在会议上表达清楚，就不会有下面的下属找你麻烦的事情了。</p><p><span class="fontLW">林短信</span><span>老大，为什么要搞这个新项目啊？现在的项目不是盈利很好吗？我们对那个领域又不熟，去了不也是送人头吗？</span></p><p><span class="fontBlue">我</span><span>你也看过我们的业绩报表，对比去年同期，我们营业额下降10%。</span></p><p><span class="fontBlue">我</span><span>正因为大家对这个领域都不熟，我们才有机会抢占先机，对你个人来说也是一个不错的提升机会。</span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>可以看出，林薇对于前面的会议上说的变革缘由并不是很清楚。通过告诉林薇营业额的下降和对公司和个人的收益，能够让林薇理解到底为什么要变。</p></div><p><span class="fontWY">魏宇</span><span>老板，听说我们要做编程游戏了，太好了！我之前有关注过这方面的信息，我觉得我们一定能成功！</span></p><p><span class="fontBlue">我</span><span>很高兴听到你这么说，说说看你对这个项目的理解。</span></p><p><span class="fontWY">魏宇</span><span>不就是要开战了嘛？不过我不确定对我来说到底会有怎么样的变化？</span></p><p><span class="fontBlue">我</span><span>这是个全新领域，我们都要学习新的内容。具体做什么我们在项目启动会上会有个初步讨论。目前你需要尽快把手里的工作交接出去，熟悉新项目，把重心放在新产品上。</span></p><p><span class="fontWY">魏宇</span><span>好的，老板。我知道了，我接下来就准备起来了。</span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>通过对话可以看出，魏宇对变革是持适应变革的态度的，这个时候，如果不能讲清楚变革的内容，可能就会把下属从适应的阶段推向观望的边缘。</p></div><p><span class="fontKS">柯胜</span><span>老大，我不想做这个新项目！我现在手里的XX产品快要上线，已经忙成狗了！</span></p><p><span class="fontBlue">我</span><span>看起来你是不理解这个决定。我理解这时抽调你过来会打乱你原本的计划，我们需要讨论下解决方案。</span></p><p><span class="fontKS">柯胜</span><span>做这个新产品对我们到底有什么好处啊？</span></p><p><span class="fontBlue">我</span><span>我们的新产品将会是市面上首款此类型的游戏，不仅能帮公司稳固在行业内的地位，提升营业额，而且，我想届时你在游戏产品界的地位，就更是当之无愧的一哥了。</span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>很显然柯胜对变革是抗拒的心态，会议中如果没有把变革的对公司、组织或个人的收益，就会出现柯胜这样怒气腾腾的状态。</p></div>' +
      //   '<p class="changeTitle fontBlod">有人抗拒，快去灭火</p><p>已经是周四的上午10:00，你仍然没有收到柯胜的报告。你决定找他聊一聊。</p><p><span class="fontKS">柯胜</span><span>老板，你找我啊。</span></p><p><span class="fontBlue">我</span><span>柯胜，上次会议说到新项目的调研报告，我还没收到你的。我想了解一下，是有什么问题吗？</span></p><p><span class="fontKS">柯胜</span><span>老大，你知道的啊。XXX产品的新版本才刚刚上市，要做的事情很多。我每天晚上整理数据和用户评论都要弄到很晚……</span></p><p>【导师反馈】懂他才能搞定他，了解下属感受是化解抗拒情绪的关键一步。</p><p><span class="fontBlue">我</span><span>我看到你对A产品新版本的热情，现在这个阶段你一定放不开手。</span></p><p><span class="fontKS">柯胜</span><span>是啊，自己一手做出来的产品，交给别人总是不放心啊。</span></p><p>【导师反馈】你很好地同理了下属的情绪，接下来要怎么见招拆招？</p><p><span class="fontBlue">我</span><span>编程游戏的项目势在必行，这个在团队中我也已经沟通多次。可以说说现在让你把重心放到新项目，你自己有什么担心或困难吗？</span></p><p><span class="fontKS">柯胜</span><span>对新项目我的确是有点担心。我跟做这行的朋友聊过，他说这个领域局势很不明朗，大家都还在烧钱，盈利模式也不清楚。现在就要去趟这浑水，我心里有点慌。</span></p><p>【导师反馈】引导下属说出了担忧和疑虑，为你点赞！</p><p><span class="fontBlue">我</span><span>我理解你资源上的压力，还有对新项目前景的担心，让我们一一来解决。先谈什么呢？</span></p><p><span class="fontKS">柯胜</span><span>老实说我主要是担心这个项目的前景，担心公司，也担心自己的投入到时一场空。</span></p><p>【导师反馈】Get到了下属担心的点，接下来要如何回应呢？</p><p><span class="fontBlue">我</span><span>谢谢你的坦诚，公司在确定这个项目前做过一些调研分析，结果是积极的，才会决定启动这个项目。我可以请小A和你分享。（小A分享-语音）</span></p><p><span class="fontOrange">小A</span><span>我们之前已经做过调研，结果还是比较积极的。不过，任何创新过程都存在风险和不确定性，所以需要项目组配合做更深入的调研，我们需要根据调研结果来规划项目并管理风险。</span></p><p><span class="fontBlue">我</span><span>我们团队有责任及时反馈市场和用户信息，帮助公司做决策。就先聚焦在我们能做的部分吧。</span></p><p><span class="fontKS">柯胜</span><span>（无奈脸）也只能这样了。【一脸“有句话不知当不当讲”的样子】</span></p><p>【导师反馈】下属似乎还有顾虑，怎样才能让他心定？</p><p><span class="fontBlue">我</span><span>还是你对新项目有其他担心？没关系，说来听听。</span></p><p><span class="fontKS">柯胜</span><span>我在这块是“小白”，现在要做还真有点不知道该从哪里下手。（我是谁？我从哪里来？我要做什么？……）</span></p><p><span class="fontBlue">我</span><span>对你来说这的确是一个全新的领域，我能理解你的无力感。我们来看看可以做些什么让你快速上手。</span></p><p><span class="fontKS">柯胜</span><span>我可以自己找一些这方面的书或网上的资料，先看起来。</span></p><p>【导师反馈】在你的引导下，下属提出了解决方案，给你撒花花~</p><p><span class="fontBlue">我</span><span>我了解到魏宇对新产品领域是有一些研究的，可以邀请他来做个分享，这样你觉得可以帮助到你尽快熟悉起来吗</span></p><p><span class="fontKS">柯胜</span><span>那当然咯，有他的分享，我想一定能更快熟悉这块的。</span></p><p>【导师反馈】你不仅帮助下属化解了情绪，还提供了支持，给你加鸡腿！</p><p>你帮柯胜把变革中要做的事进行了梳理。（记事本形式呈现）</p><p class="imgBlock"><img style="width: 100%;" src="../../assets/picture/casepracticerevolution/bestRoadNote.png" /></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>在会议阶段柯胜的抗拒情绪就比较明显了。这个情况下，首先要运用变革加速器二，收集他的感受和想法并且表示同理；然后再运用变革加速器三及鼓励参与，帮助他梳理变革中不可掌控、可掌控、可影响的部分，让他重获掌控感。</p></div>'+
      //   '<p class="changeTitle fontBlod">变革ing，跟进！跟进！再跟进</p><p>两个月之后，你组织项目组成员开了一次会议，会议的目的：</p><div class="bg-lightOrange"><p class="fontOrange">「最佳选择」</p><p class="smLineHeight">1.回顾项目进展。</p><p class="smLineHeight">2.对做得好的给予表扬，加强自信</p><p class="smLineHeight">3.对做得不好的，给予鼓励，维护自尊</p><p class="smLineHeight">4.提供必要的支持</p></div><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>变革过程中的监控和回顾对变革的成功起很大的作用，那么跟进会议就必不可少了，在会议上难道只是跟进项目嘛？并不然，及时奖励、提供支持才能让变革的走向成功。</p></div>'+
      //   '<p>会议开始了，大家轮流进行汇报，首先是开发工程师魏宇汇报工作。</p><p><span class="fontWY">魏宇</span><span>经过这两个月的加班加点，调研的内容已经完成，同时，开发已经……（一切顺利，成果显著）。【具体内容，成果显著】</span></p><p class="fontOrange">「最佳选择」</p><p><span class="fontBlue">我</span><span>大家对你的调研报告评价很高，同时，你还提前完成部分开发工作，给后期的工作打下了良好的基础，非常给力哦！ </span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>魏宇对变革本身就是适应的状态，并且在变革中取得了不错的成绩，这个时候的鼓励就像一针强心针，能够有助变革顺利进行。</p></div>'+
      //   '<p>接下来是项目经理林薇汇报工作。</p><p><span class="fontLW">林薇</span><span>老大，我已经把项目的整体排期方案做好了，但是涉及到数据分析方面的内容还没有开始做，因为市场部迟迟没有给到数据。【具体内容，成果一般，需要协助】</span></p><p><span class="fontBlue">我</span><span>你的排期方案做得非常细致，考虑很周全，不亏是公认的“大管家”。拿不到市场部数据会导致延期，你准备怎么跟进？</span></p><p><span class="fontLW">林薇</span><span>催了几次都不见效果，我打算约他们主管谈下，看看到底什么情况。</span></p><p>【导师反馈】维护自尊，鼓励参与，让下属动起来。</p><p><span class="fontBlue">我</span><span>嗯，了解清楚状况再看看怎么解决比较好，反复催可能不会有效果。谈完后如果有需要我帮忙的地方告诉我。</span></p><p><span class="fontLW">林薇</span><span>谢谢老大的建议和支持，我尽快了解清楚后再采取行动。</span></p><p>【导师反馈】鼓励建议加支持，效果翻倍。墙都不扶就服你！</p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>变革本身就是不易的，林薇一开始对变革持观望态度，在进度一般的情况下，指责和不信任都会让她失去继续进行下去的信心，给予支持才能够让她有动力将变革进行到底。</p></div>' +
      //   '<p>最后，是产品设计师柯胜汇报工作。</p><p><span class="fontKS">柯胜</span><span>老大，我这边的部分，因为难度确实比较大，我花了大半个月的时间才刚刚了解完市场情况，做完调研报告，具体的情况是……（进度不佳，成果一般）。【具体内容，进展缓慢】</span></p><p><span class="fontBlue">我</span><span>你调研报告中的目标客户群体分析，让我们看到原本的假设里面忽略的部分，而且你的验证非常确凿，对后面产品的设计有很大的参考价值。</span></p><p><span class="fontKS">柯胜</span><span>非常感谢老大的认可，接下来我会更加努力的！</span></p><p>【导师反馈】肯定下属的成果，维护自尊。给你99分，剩下1分怕你骄傲。</p><p><span class="fontBlue">我</span><span>关于进度的问题，你这边是有什么困难吗？</span></p><p><span class="fontKS">柯胜</span><span>产品设计过程中牵涉到的人比较多，前期讨论时，很难约大家的时间。另外，因为没能及时调整方案，并且通知项目组其他人，所以项目进展不太顺利。</span></p><p>【导师反馈】循循善诱让下属敞开心扉，继续努力哦！</p><p><span class="fontBlue">我</span><span>我又要顾着调整方案，又要协调那么多人员，你的确不容易啊！那接下来有什么计划赶上进度吗？</span></p><p><span class="fontKS">柯胜</span><span>目前我们已经调整了方案，现在的计划是……（叙述计划）</span></p><p>【导师反馈】下属胸有成竹，胜利在望的感觉不错吧？</p><p><span class="fontBlue">我</span><span>嗯，有任何问题，可以随时找我。你是我们的骨干产品设计师，相信你能很快赶上进度，保证我们如期交付。</span></p><p><span class="fontKS">柯胜</span><span>老大，我一定不负众望。</span></p><p>【导师反馈】下属信心满满，干劲十足。看好你哟！</p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>变革的过程中，柯胜一直持抗拒的态度。在进度不佳的状况下，你不仅不应该大骂一顿，反而应该看到他值得肯定的地方维护自尊，运用提问的方式帮助他找出跟上进度的方案。</p></div><p>会议结束，项目持续进行中…</p>';


      this.apiService.ajax({
        'type':'get',
        'url':'/api/exerciseTutor/'+this.exerciseId
      }).subscribe(result=>{
        this.tutor = result.tutor;
        this.optimum = result.optimum;
      });

    });
  }

  updateExerciseReports(){
  	this.apiService.ajax({
	      'type':'get',
	      'url':'/sr/insideapi/updateExerciseReports?exerciseId='+this.exerciseId
	  }).subscribe(result=>{
	      this.getKasInfo();
	  });
  }

  getKasInfo(){
  		this.apiService.ajax({
        'type':'get',
        // 'url':'/api/practices/'+this.exerciseId+'/'+this.practiceId+'/report'
        'url':'/sr/driveChange/reports/'+this.exerciseId+'/'+this.practiceId
      }).subscribe(result=>{

        //无报告数据转向列表页
      	this.practiceMetaId = result.practiceMetaId;
        this.report = result.reports.kas;
        this.reportName = result.reports.name;
        this.finished = result.allExerciseFinished;
        this.getLevelInfo(result.reports);

      });
  }

  getLevelInfo(reports){
  	let that = this;
  	$.ajax({
      url: "/sr/insideapi/getlevel",
      type: "post",
      dataType:'json',
      contentType:'application/json;charset=utf-8',
      data:JSON.stringify(this.getKaList(reports)) ,
      async: false,
      headers : {
        'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
        'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
      },
      success:function(result){
        if(result && result != ""){
          that.reportKAData = result;
          that.targetShow = 1;
        }else{
          that.targetShow = 0;
        }
      },
      error:function(er){
        that.targetShow = 0;
        if(er.status === 401 && Number(er.responseJSON.code) === 106){
          that.storeService.notification.notAuthed.next(true);
        }
      }
    });

    if(reports.name=='组织与计划'){
      this.mode = 2;
      if(that.targetShow == 0){
        this.lvCls = this.mode+'';
      }else{
        this.lvCls = this.mode+' bgBlur';
      }
      this.starPicUrl='/casepracticepando/star2.png';
    }else if(reports.name=='影响力'){
      this.mode = 3;
      if(that.targetShow == 0){
        this.lvCls = this.mode+'';
      }else{
        this.lvCls = this.mode+' bgBlur';
      }
      this.starPicUrl='/casepracticeteam/star_report.png';
    }else if(reports.name=='驱动变革'){
      this.mode = 4;
      if(that.targetShow == 0){
        this.lvCls = this.mode+'';
      }else{
        this.lvCls = this.mode+' bgBlur';
      }
      this.starPicUrl='/casepracticeteam/star_report2.png';
    }else{
      this.mode = 1;
      if(that.targetShow == 0){
        this.lvCls = this.mode+'';
      }else{
        this.lvCls = this.mode+' bgBlur';
      }
      this.starPicUrl='/casepracticeteam/star_report.png';
    }

    if(that.targetShow === 0){
      this.isShowReportLv = false;
    }else{
      this.isShowReportLv = true;
    }

    setTimeout(()=>{
  		this.itemClickEnable = true;
  	},500);
  }

  ngAfterViewInit(){
    let that = this;
    this.commonService.initPage({
      'backgroundColor':'white'
    });
    $(document).ready(function(){
      var listenerTimeout = setInterval(function(){
        var bestPathEle = document.getElementById('bestPathBox'),
            analysisEle =  document.getElementById('analysisContent'),
            tutorEle = document.getElementById('tourReviewBox');
        if(bestPathEle !== null && analysisEle !== null && tutorEle != null){
          bestPathEle.addEventListener('scroll', that.onBestPathScroll);
          analysisEle.addEventListener('scroll', that.onAnalysisScroll);
          tutorEle.addEventListener('scroll', that.onTutorScroll);
          clearInterval(listenerTimeout);
        }
      }, 500);
    });
  }

  /*
    格式化KA对象方法
     report：传递一个报告对象
   */
  getKaList(report){
  	let kaJson = {id:report.id,name:report.name,type:report.type,kas:{},exercisesId:this.exerciseId,questionId:null,optionId:null};
  	if(window["exercises" + this.exerciseId] != null){
  		let exerciseConfig = window["exercises" + this.exerciseId];
  		kaJson.questionId = exerciseConfig.questionId;
  		kaJson.optionId = exerciseConfig.optionId;
  	}

    if(report){
      for(let i = 0;i <report.kas.length; i++){
        let kaItem = report.kas[i];
        if(kaItem){
          //kaJson.kas.push({name:kaItem.name,value:Number(kaItem.value)});
          kaJson.kas[kaItem.name] = kaItem.value;
        }
      }
    }
    return kaJson;
  }

  close(){
    this.apiService.ajax({
      'type': 'get',
      'url':'/api/learningpathes/'+this.learningPathId
    }).subscribe(result=>{

      //转向情景列表
			let link = this.abilityConfig.getPracticeLinkList(result.name,this.learningPathId,this.practiceMetaId);
			if(link.length > 0){
        if(this.type){
          this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
            this.router.navigate(link);
        }
			}

    });
  }


  onBestPathScroll(){
    var overlay = document.getElementById('bestPathBox');
    if (overlay.scrollTop < 1) {
        overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1)                         {
        overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onAnalysisScroll(){
    var overlay = document.getElementById('analysisContent');
    console.log("scroll1");
    if (overlay.scrollTop < 1) {
        overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1)                         {
        overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onTutorScroll(){
    var overlay = document.getElementById('tourReviewBox');
    if (overlay.scrollTop < 1) {
        overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1)                         {
        overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  subWrapOneOut(){
       $('#subWrapOne').fadeOut(function () {
           $('#subWrapTwo').fadeIn();
           $('#btnWrap').fadeIn();
       });
  }

  tourReviewBoxIn(){
      $('#tourReviewShade').fadeIn();
      $('#tourReviewBox').fadeIn();
      $('.closeBtn'+this.skinColor).fadeIn();
      this.pathClickable = false;
  }

  tourReviewBoxOut(){
      $('#tourReviewShade').fadeOut();
      $('#tourReviewBox').fadeOut();
      $('.closeBtn'+this.skinColor).fadeOut();
      this.pathClickable = true;
  }

  bestPathIn(){
      if(!this.pathClickable){
        return;
      }
      $('.closeBtn'+this.skinColor).fadeIn();
      this.bestPathBoxShow = true;
      $('#shade').fadeIn();
  }

  bestPathOut(){
      $('.closeBtn'+this.skinColor).fadeOut();
      this.bestPathBoxShow = false;
      $('#shade').fadeOut();
  }

  redo() {

      if(!this.pathClickable || this.redoClickedStatus){
        return;
      } else{
        this.redoClickedStatus = true;
      }

      this.apiService.ajax({
	      'type':'get',
	      'url':'/sr/driveChange/reset/'+this.exerciseId
	    }).subscribe(result=>{
	      // let link = ['case-practice-revolution',this.learningPathId,this.practiceMetaId];
        let link = ['case-practice-revolution',this.practiceId,this.exerciseId,this.learningPathId,this.practiceMetaId];
        if(this.type){
          this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
            this.router.navigate(link);
        }
	    });

  }

  analysisBoxIn(i){
		if(!this.itemClickEnable){
			return false;
		}
    let _this = this;
    this.currentName = this.report[i].name;
    this.currentDescription = this.report[i].description;
    this.currentTotal = this.report[i].value;
    this.currentAnalysis = this.report[i].analysis;
    $('#analysisShade').fadeIn();
    // 滚动到订端
    $('#analysisContent').scrollTop(0);
      // $('#analysisBox').fadeIn();
    this.analysisBoxShow = true;
    $('body').css('overflow-y', 'hidden');
    setTimeout(function(){

      _this.starShow = true;

    }, 300);

    this.pathClickable = false;

      document.getElementById('analysisShade').ontouchmove = function(e){ e.preventDefault(); }
      document.getElementById('analysisHead').ontouchmove = function(e){ e.preventDefault(); }
      document.getElementById('closeBtn3').ontouchmove = function(e){ e.preventDefault(); }

  }

  analysisBoxOut(){

      $('#analysisShade').fadeOut();
      this.analysisBoxShow = false;
      $('body').css('overflow-y', 'scroll');
      this.starShow = false;
      this.pathClickable = true;

  }

  goToList(){
    if(this.goToListClickedStatus){
      return;
    } else{
      this.goToListClickedStatus = true;
    }
    this.apiService.ajax({
      'type': 'get',
      'url':'/api/learningpathes/'+this.learningPathId
    }).subscribe(result=>{
      //转向情景列表
			let link = this.abilityConfig.getPracticeLinkList(result.name,this.learningPathId,this.practiceMetaId);
			if(link.length > 0){
        if(this.type){
          this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
            this.router.navigate(link);
        }
			}
    });
  }

  linkToPostSurvey(){
      this.apiService.ajax({
          'type': 'get',
          'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
      }).subscribe(result=>{
          this.learningPathMetaId = result;
          this.apiService.getOrCreateLearningPath(this.learningPathMetaId).subscribe(result=>{
              this.learningPath = result.data;
              if(this.learningPath.subItems.length==3){

                  this.apiService.ajax({
                      'type':'get',
                      'url': '/sr/learningtour',
                  }).subscribe(result=>{
                      this.learningTour = result;
                      let link = ['survey', this.learningTour.tour_id, 3,2];
                      this.router.navigate(link);
                  });

              }else{

                  let link = ['survey', this.learningPath.id, this.learningPath.subItems[4].surveyMetaId,1];
                  this.router.navigate(link);

              }
          });
      });
  }
  //
  // getMockData() {
  //     return {
  //         "id": 1962,
  //         "practiceMetaId": 1,
  //         "reports": [{
  //             "id": 2280,
  //             "name": "\u60c5\u666f\u6a21\u62df2",
  //             "type": "exercise",
  //             "kas": [{
  //                 "name": "\u8bf4\u660e\u76ee\u7684",
  //                 "value": 1,
  //                 "description": "\u8bf4\u660e\u8ba8\u8bba\u7684\u76ee\u7684\u4e0e\u91cd\u8981\u6027\uff0c\u5f00\u542f\u8ba8\u8bba\uff1b\u786e\u4fdd\u53cc\u65b9\u7406\u89e3\u4e00\u81f4\u3002",
  //                 "analysis": "\u5f00\u542f\u8ba8\u8bba\u505a\u5f97\u597d\uff0c\u8f85\u5bfc\u5c31\u80fd\u6210\u529f\u4e00\u534a\u3002\u5728\u8f85\u5bfc\u5f00\u573a\u65f6\uff0c\u6709\u4e24\u70b9\u7f3a\u4e00\u4e0d\u53ef\uff1a\u8fd9\u573a\u8ba8\u8bba\u6253\u7b97\u8c08\u4ec0\u4e48\u95ee\u9898\uff1f\u4e3a\u4ec0\u4e48\u8fd9\u4e2a\u95ee\u9898\u5f88\u91cd\u8981\uff0c\u4f1a\u5bf9\u5176\u4ed6\u4eba\u4ea7\u751f\u4ec0\u4e48\u6837\u7684\u5f71\u54cd\uff1f\u8fd9\u6837\uff0c\u4e0b\u5c5e\u624d\u80fd\u4e86\u89e3\u8f85\u5bfc\u8ba8\u8bba\u7684\u539f\u56e0\u4f55\u5728\uff0c\u660e\u767d\u81ea\u5df1\u7684\u6240\u4f5c\u6240\u4e3a\u5df2\u7ecf\u9020\u6210\u4e00\u5b9a\u7684\u540e\u679c\uff0c\u6709\u5f85\u6539\u8fdb\u3002  \u7136\u800c\u5728\u73b0\u5b9e\u5de5\u4f5c\u4e2d\uff0c\u7ba1\u7406\u8005\u5f80\u5f80\u96be\u4ee5\u4e24\u8005\u517c\u987e\u3002\u5c24\u5176\u662f\u7b2c\u4e8c\u70b9\uff0c\u95ee\u9898\u7684\u91cd\u8981\u6027\u548c\u5f71\u54cd\uff0c\u5f88\u5bb9\u6613\u5728\u8f85\u5bfc\u4e2d\u88ab\u5ffd\u7565\u3002\u6bd4\u5982\uff0c\u5728\u8fd9\u4e2a\u6848\u4f8b\u4e2d\uff0c\u5f88\u591a\u4e3b\u7ba1\u5c31\u4f1a\u5fd8\u8bb0\u5411\u5b63\u5b81\u89e3\u91ca\u8fd9\u4efd\u62a5\u544a\u5f88\u91cd\u8981\uff0c\u56e0\u4e3a\u76f4\u63a5\u548c\u738b\u7ecf\u7406\u662f\u5426\u80fd\u6ee1\u8db3\u5ba2\u6237\u7684\u9700\u6c42\u6709\u76f4\u63a5\u5173\u7cfb\u3002  \u5bf9\u4e8e\u4e0a\u8ff0\u63d0\u5230\u7684\u4e24\u4e2a\u8981\u70b9\uff0c\u7b2c\u4e00\u70b9\u4f60\u5728\u8fd9\u6b21\u7684\u7ec3\u4e60\u4e2d\u90fd\u6709\u6240\u8868\u73b0\uff0c\u4f46\u662f\u8fd8\u6709\u5f85\u63d0\u9ad8\u3002\u6bd4\u5982\u5728\u8bf4\u660e\u8ba8\u8bba\u76ee\u7684\u65f6\uff0c\u5f00\u95e8\u89c1\u5c71\u4e5f\u5f88\u91cd\u8981\uff0c\u8fd9\u6837\u53ef\u4ee5\u907f\u514d\u8fc7\u5ea6\u5bd2\u6684\u800c\u9020\u6210\u8dd1\u9898\u6216\u8005\u65f6\u95f4\u7684\u6d6a\u8d39\uff1b\u5f53\u7136\uff0c\u4e0d\u987e\u4e0b\u5c5e\u611f\u53d7\uff0c\u4e0a\u6765\u5c31\u5bf9\u4e0b\u5c5e\u6a2a\u52a0\u6307\u8d23\u7684\u884c\u4e3a\u4e5f\u4e0d\u53ef\u53d6\uff0c\u5f88\u5bb9\u6613\u5f15\u8d77\u5bf9\u65b9\u7684\u53cd\u5f39\u3002  \u4f46\u7b2c\u4e8c\u70b9\u672a\u5f97\u5230\u5145\u5206\u5c55\u73b0\uff0c\u5efa\u8bae\u4f60\u4ee5\u540e\u5bf9\u95ee\u9898\u7684\u91cd\u8981\u6027\u4e5f\u9700\u8981\u5145\u5206\u8bf4\u660e\uff0c\u53ef\u4ee5\u4ece\u4e2a\u4eba\u3001\u5ba2\u6237\u3001\u56e2\u961f\u3001\u7ec4\u7ec7\u7b49\u591a\u4e2a\u89d2\u5ea6\u6765\u5207\u5165\u8bf4\u660e\u5f71\u54cd\u3002"
  //             }, {
  //                 "name": "\u6f84\u6e05\u7ee9\u6548",
  //                 "value": 1,
  //                 "description": "\u901a\u8fc7\u63d0\u95ee\u8fdb\u4e00\u6b65\u6f84\u6e05\u8bae\u9898\u53ca\u539f\u7531\uff1b\u5bfb\u6c42\u5bf9\u65b9\u7684\u60f3\u6cd5\uff0c\u5171\u540c\u5236\u5b9a\u8ba1\u5212\uff1b \u6c9f\u901a\u65f6\uff0c\u9664\u4e86\u8bf4\u660e\u81ea\u5df1\u7684\u610f\u89c1\uff0c\u4e5f\u8981\u5bfb\u6c42\u5bf9\u65b9\u7684\u60f3\u6cd5\uff0c\u8bf4\u3001\u542c\u4e4b\u95f4\u8981\u6709\u6240\u5e73\u8861\u3002",
  //                 "analysis": "\u8fd9\u4e2a\u884c\u4e3a\u7684\u6838\u5fc3\u5728\u4e8e\u201c\u6f84\u6e05\u539f\u56e0\u201d\u4e0e\u201c\u8868\u8fbe\u7ee9\u6548\u201d\u5e76\u91cd\u3002\u5728\u8f85\u5bfc\u4e2d\uff0c\u5927\u90e8\u5206\u7684\u7ba1\u7406\u8005\u90fd\u4f1a\u8ddf\u4e0b\u5c5e\u6307\u51fa\u54ea\u4e9b\u5730\u65b9\u51fa\u73b0\u4e86\u95ee\u9898\u3001\u6709\u4ec0\u4e48\u9700\u8981\u6539\u8fdb\u7684\uff0c\u81f3\u4e8e\u95ee\u9898\u51fa\u73b0\u7684\u539f\u56e0\uff0c\u5f80\u5f80\u4f1a\u88ab\u4e3b\u7ba1\u5ffd\u7565\u3002  \u6bd4\u5982\uff0c\u5728\u8fd9\u4e2a\u7ec3\u4e60\u4e2d\uff0c\u5b63\u5b81\u8fdf\u4ea4\u62a5\u544a\u548c\u62a5\u544a\u8d28\u91cf\u5ba2\u6237\u4e0d\u6ee1\u610f\u662f\u4e8b\u5b9e\uff0c\u4f46\u662f\u4f5c\u4e3a\u4e3b\u7ba1\u8fd8\u662f\u5e94\u8be5\u5148\u6df1\u5165\u4e86\u89e3\u8fd9\u4e9b\u95ee\u9898\uff1a\u4e3a\u4ec0\u4e48\u4f1a\u8fdf\u4ea43\u5929\uff1f\u5979\u660e\u660e\u5f88\u4e13\u4e1a\u4e3a\u4ec0\u4e48\u5199\u7684\u62a5\u544a\u8fd8\u4e0d\u6ee1\u8db3\u738b\u7ecf\u7406\u7684\u9700\u6c42\uff1f\u5f53\u6211\u4eec\u4e86\u89e3\u5230\u8fd9\u4e9b\u539f\u56e0\u540e\uff0c\u518d\u53bb\u8ddf\u5979\u8c08\u600e\u4e48\u89e3\u51b3\u5de5\u4f5c\u7ed3\u679c\u4e0d\u4f73\u7684\u95ee\u9898\uff0c\u5c31\u66f4\u6709\u9488\u5bf9\u6027\u5566\u3002  \u5728\u8fd9\u4e2a\u7ec3\u4e60\u4e2d\uff0c\u4f60\u8fdb\u884c\u4e86\u4e00\u5b9a\u7684\u6f84\u6e05\u3002\u4f46\u503c\u5f97\u6ce8\u610f\u7684\u662f\uff0c\u5373\u4f7f\u4e0b\u5c5e\u8868\u73b0\u51fa\u7684\u95ee\u9898\u53ea\u6709\u4e00\u4e2a\uff0c\u5176\u80cc\u540e\u7684\u539f\u56e0\u5f88\u6709\u53ef\u80fd\u662f\u591a\u91cd\u7684\u3002\u6240\u4ee5\u9700\u8981\u6211\u4eec\u591a\u52a0\u8be2\u95ee\uff0c\u6bd4\u5982\u53ef\u4ee5\u95ee\uff0c\u201c\u80fd\u544a\u8bc9\u6211\u4e3a\u4ec0\u4e48\u5417\u201d\u3001\u201c\u8fd9\u662f\u600e\u4e48\u56de\u4e8b\u201d\u3001\u201c\u8fd8\u6709\u522b\u7684\u539f\u56e0\u5417\u201d\uff0c\u7b49\u7b49\u3002\u5c06\u539f\u56e0\u4e86\u89e3\u900f\u5f7b\u4e4b\u540e\uff0c\u518d\u8ddf\u4e0b\u5c5e\u8c08\u600e\u4e48\u6539\u8fdb\uff0c\u4f1a\u66f4\u52a0\u987a\u5229\u6709\u6548\u3002  \u6240\u4ee5\uff0c\u5728\u8f85\u5bfc\u4e0b\u5c5e\u65f6\uff0c\u6211\u4eec\u4e0d\u59a8\u5148\u95ee\u6e05\u695a\u75c7\u7ed3\u6240\u5728\uff0c\u518d\u6307\u51fa\u4e0b\u5c5e\u7684\u7ee9\u6548\u95ee\u9898\u3002\u5728\u5c06\u539f\u56e0\u4e86\u89e3\u900f\u5f7b\u4e4b\u540e\uff0c\u518d\u548c\u4e0b\u5c5e\u4e00\u8d77\u5bfb\u6c42\u89e3\u51b3\u65b9\u6cd5\u3002"
  //             }, {
  //                 "name": "\u8868\u8fbe\u671f\u671b",
  //                 "value": 1,
  //                 "description": "\u8bf4\u660e\u4e0e\u6f84\u6e05\u9700\u8981\u6539\u5584\u7684\u90e8\u5206\u6216\u627f\u63a5\u65b0\u4efb\u52a1\u6240\u9700\u7684\u51c6\u5907\uff1b\u8bf4\u660e \u7ee9\u6548\u5bf9\u4e2a\u4eba\u3001\u56e2\u961f\u53ca\u7ec4\u7ec7\u7684\u5f71\u54cd\uff1b\u5206\u4eab\u5177\u4f53\u8303\u4f8b\u548c\u76f8\u5173\u4fe1\u606f\u4ee5\u5e2e\u52a9\u5bf9\u65b9\u7406\u89e3\u3002 ",
  //                 "analysis": "\u5982\u679c\u5728\u8f85\u5bfc\u65f6\uff0c\u4e0b\u5c5e\u610f\u5174\u9611\u73ca\uff0c\u5bf9\u4f60\u7684\u8bdd\u9898\u91c7\u53d6\u6c89\u9ed8\u5bf9\u7b56\uff1b\u6216\u8005\u9632\u5fa1\u76fe\u5168\u5f00\uff0c\u968f\u65f6\u5904\u4e8e\u7206\u53d1\u8fb9\u7f18\uff0c\u90a3\u8be5\u600e\u4e48\u529e\uff1f\u5982\u679c\u7f6e\u4e4b\u4e0d\u7406\uff0c\u4f60\u4eec\u6050\u6015\u8fde\u8c08\u8bdd\u90fd\u96be\u4ee5\u4e3a\u7ee7\uff0c\u66f4\u522b\u8bf4\u8ba9\u4e0b\u5c5e\u505a\u51fa\u4ec0\u4e48\u6539\u53d8\u4e86\u3002\u6240\u4ee5\uff0c\u5728\u8f85\u5bfc\u4e2d\uff0c\u6211\u4eec\u4e0d\u4ec5\u8981\u7740\u529b\u4e8e\u95ee\u9898\u7684\u89e3\u51b3\uff0c\u4e0b\u5c5e\u7684\u60c5\u7eea\u72b6\u6001\u4e5f\u9700\u8981\u5168\u7a0b\u5173\u6ce8\u3002  \u8fd9\u4e2a\u7ec3\u4e60\u4e2d\uff0c\u5b63\u5b81\u591a\u6b21\u51fa\u73b0\u4e0d\u6ee1\u6216\u8005\u987e\u8651\u8fd9\u4e24\u79cd\u60c5\u7eea\uff0c\u6bd4\u5982\u5bf9\u4e8e\u81ea\u5df1\u8f9b\u82e6\u505a\u7684\u62a5\u544a\u5ba2\u6237\u4e0d\u6ee1\u610f\u8fd9\u4ef6\u4e8b\u4e0a\uff0c\u5979\u5c31\u6709\u5f88\u5f3a\u7684\u62b5\u89e6\u60c5\u7eea\uff0c\u8fd9\u65f6\u4f60\u53ef\u4ee5\u4f7f\u7528\u201c\u540c\u7406\u5fc3\u201d\uff0c\u56de\u5e94\u5979\u7684\u906d\u9047\u548c\u611f\u53d7\uff08\u201c\u8f9b\u82e6\u4ed8\u51fa\u5f88\u591a\uff0c\u5374\u88ab\u4eba\u62b1\u6028\uff0c\u4f60\u80af\u5b9a\u4f1a\u89c9\u5f97\u59d4\u5c48\u5427\u3002\u201d\uff09\u3002\u800c\u5728\u60f3\u65b9\u6848\u7684\u9636\u6bb5\uff0c\u5979\u5bf9\u4e8e\u548c\u738b\u7ecf\u7406\u8c08\u6709\u987e\u8651\u65f6\uff0c\u4e5f\u53ef\u4ee5\u901a\u8fc7\u8ba4\u53ef\u5979\u7684\u80fd\u529b\uff0c\u5f3a\u8c03\u5bf9\u4e8e\u5979\u4e2a\u4eba\u7684\u804c\u4e1a\u53d1\u5c55\uff0c\u6765\u9f13\u52b1\u5979\u53bb\u627f\u62c5\u3002  \u6211\u4eec\u6765\u770b\u770b\u4f60\u5728\u201c\u7ef4\u6301\u52a8\u529b\u201d\u4e0a\u7684\u8868\u73b0\u3002\u4f60\u5728\u7ec3\u4e60\u4e2d\uff0c\u5bf9\u5b63\u5b81\u60c5\u7eea\u56de\u5e94\u6709\u6240\u6b20\u7f3a\u3002\u5f88\u591a\u4e3b\u7ba1\u5728\u8f85\u5bfc\u65f6\uff0c\u5f80\u5f80\u4f1a\u6709\u201c\u91cd\u4e8b\u4e0d\u91cd\u4eba\u201d\u7684\u503e\u5411\uff0c\u5bf9\u4e0b\u5c5e\u7684\u60c5\u7eea\u53d8\u5316\u4e0d\u591f\u654f\u9510\u3002\u4e8b\u5b9e\u4e0a\uff0c\u5bf9\u4e0b\u5c5e\u60c5\u7eea\u7684\u5173\u6ce8\u4f1a\u6709\u5229\u4e8e\u8f85\u5bfc\u6548\u679c\u7684\u52a0\u6210\u3002\u5efa\u8bae\u4f60\u5728\u5979\u6709\u5f88\u5927\u7684\u62b5\u89e6\u60c5\u7eea\u65f6\uff0c\u540c\u7406\u5979\uff0c\u5728\u5979\u6709\u987e\u8651\u53bb\u627f\u62c5\u4efb\u52a1\u65f6\uff0c\u80af\u5b9a\u5979\uff0c\u9f13\u52b1\u5979\u53bb\u627f\u62c5\u3002\u8fd9\u6837\u5bf9\u4e8e\u6574\u4e2a\u8f85\u5bfc\u7684\u987a\u5229\u8fdb\u884c\u548c\u6700\u7ec8\u8f85\u5bfc\u76ee\u7684\u7684\u8fbe\u6210\u90fd\u4f1a\u975e\u5e38\u6709\u5e2e\u52a9\u3002  \u5728\u73b0\u5b9e\u7684\u8f85\u5bfc\u4e2d\uff0c\u540c\u6837\u4e5f\u662f\u5982\u6b64\u3002\u5584\u7528\u540c\u7406\u5fc3\uff0c\u56de\u5e94\u4e0b\u5c5e\u7684\u611f\u53d7\uff1b\u52a0\u5f3a\u81ea\u4fe1\uff0c\u80af\u5b9a\u5bf9\u65b9\u7684\u5de5\u4f5c\u8d21\u732e\u548c\u80fd\u529b\u3002\u8fd9\u6837\uff0c\u4e0d\u4f46\u8f85\u5bfc\u8fc7\u7a0b\u66f4\u52a0\u987a\u5229\uff0c\u4e0b\u5c5e\u4e5f\u4f1a\u9f13\u8d77\u52c7\u6c14\u6765\u627f\u62c5\u81ea\u5df1\u7684\u8d23\u4efb"
  //             }, {
  //                 "name": "\u7ef4\u6301\u52a8\u529b",
  //                 "value": 5,
  //                 "description": "\u5728\u4e0d\u964d\u4f4e\u7ee9\u6548\u6311\u6218\u96be\u5ea6\u7684\u524d\u63d0\u4e0b\uff0c\u8ba4\u53ef\u4e0b\u5c5e\u7684\u4ef7\u503c\u3001\u8fdb\u6b65\u53ca\u8d21\u732e\uff1b\u5728\u5f3a\u8c03\u4e0b\u5c5e\u5fc5\u987b\u8981\u5bf9\u53cc\u65b9\u540c\u610f\u7684\u540e\u7eed\u884c\u52a8\u5c65\u884c\u8d23\u4efb\u65f6\uff0c\u4e5f\u80fd\u5bf9\u4e0b\u5c5e\u7684\u987e\u8651\u5c55\u73b0\u540c\u7406\u5fc3\u3002 ",
  //                 "analysis": "\u5f00\u653e\u5f0f\u7684\u95ee\u9898\u53ef\u4ee5\u8ba9\u4e0b\u5c5e\u66f4\u6709\u610f\u613f\u53c2\u4e0e\uff0c\u540c\u65f6\u4e5f\u53ef\u4ee5\u6fc0\u53d1\u81ea\u5df1\u7684\u601d\u8003\uff0c\u800c\u5bf9\u4e8e\u81ea\u5df1\u8bf4\u51fa\u7684\u65b9\u6848\uff0c\u4e5f\u4f1a\u66f4\u613f\u610f\u53bb\u6267\u884c\uff0c\u6700\u7ec8\u4f7f\u547d\u5fc5\u8fbe\u3002 \u201c\u4fc3\u8fdb\u53c2\u4e0e\u201d\u8fd9\u4e2a\u5173\u952e\u884c\u4e3a\uff0c\u8003\u5bdf\u7684\u5c31\u662f\u4e3b\u7ba1\u662f\u5426\u4f1a\u5728\u8f85\u5bfc\u8fc7\u7a0b\u4e2d\u4e3b\u52a8\u8be2\u95ee\u3001\u5bfb\u6c42\u4e0b\u5c5e\u7684\u53c2\u4e0e\u3002  \u8be5\u884c\u4e3a\u548c\u201c\u7ef4\u6301\u52a8\u529b\u201d\u4e00\u6837\uff0c\u4f1a\u8d2f\u7a7f\u4e8e\u6574\u4e2a\u8f85\u5bfc\u8fc7\u7a0b\u7684\u59cb\u7ec8\u3002\u6bd4\u5982\uff0c\u5728\u6f84\u6e05\u5b63\u5b81\u62a5\u544a\u665a\u4ea4\u539f\u56e0\u7684\u65f6\u5019\uff0c\u4ee5\u53ca\u5e2e\u5979\u5bfb\u627e\u548c\u738b\u7ecf\u7406\u6c9f\u901a\u7684\u65b9\u6cd5\u7684\u65f6\u5019\u3002\u90fd\u53ef\u4ee5\u901a\u8fc7\u63d0\u95ee\u6765\u4fc3\u8fdb\u5979\u53c2\u4e0e\uff0c\u5f15\u53d1\u5979\u81ea\u5df1\u601d\u8003\u3002  \u4f60\u5728\u8fd9\u4e2a\u884c\u4e3a\u4e0a\u7684\u8868\u73b0\u5f97\u5230\u4e86\u6ee1\u661f\u7684\u597d\u6210\u7ee9\uff0c\u8bf4\u660e\u5728\u8fd9\u4e2a\u7ec3\u4e60\u4e2d\uff0c\u4f60\u5728\u5404\u4e2a\u9636\u6bb5\u90fd\u5f88\u597d\u5730\u4f7f  \u7528\u4e86\u53d1\u95ee\u7684\u6280\u5de7\uff0c\u503c\u5f97\u8d5e\u626c\uff01\u5e0c\u671b\u4ee5\u540e\u5728\u5de5\u4f5c\u573a\u666f\u4e2d\uff0c\u591a\u591a\u53d1\u95ee\uff0c\u53bb\u5bfb\u627e\u4e0b\u5c5e\u5de5\u4f5c\u7ed3\u679c\u6b20\u4f73\u6216\u8005\u884c\u4e3a\u4e0d\u826f\u80cc\u540e\u7684\u771f\u6b63\u539f\u56e0\uff1b\u540c\u65f6\u8ba9\u4e0b\u5c5e\u591a\u591a\u53d1\u8868\u81ea\u5df1\u7684\u60f3\u6cd5\uff0c\u601d\u8003\u81ea\u5df1\u600e\u4e48\u53ef\u4ee5\u505a\u4e9b\u4ec0\u4e48\u6765\u6539\u8fdb\u81ea\u5df1\u7684\u7ee9\u6548\u6216\u8005\u884c\u4e3a"
  //             }, {
  //                 "name": "\u63d0\u4f9b\u652f\u6301",
  //                 "value": 1,
  //                 "description": "\u5728\u4e0d\u964d\u4f4e\u7ee9\u6548\u6311\u6218\u96be\u5ea6\u7684\u524d\u63d0\u4e0b\uff0c\u8ba4\u53ef\u4e0b\u5c5e\u7684\u4ef7\u503c\u3001\u8fdb\u6b65\u53ca\u8d21\u732e\uff1b\u5728\u5f3a\u8c03\u4e0b\u5c5e\u5fc5\u987b\u8981\u5bf9\u53cc\u65b9\u540c\u610f\u7684\u540e\u7eed\u884c\u52a8\u5c65\u884c\u8d23\u4efb\u65f6\uff0c\u4e5f\u80fd\u5bf9\u4e0b\u5c5e\u7684\u987e\u8651\u5c55\u73b0\u540c\u7406\u5fc3\u3002 ",
  //                 "analysis": "\u5f00\u653e\u5f0f\u7684\u95ee\u9898\u53ef\u4ee5\u8ba9\u4e0b\u5c5e\u66f4\u6709\u610f\u613f\u53c2\u4e0e\uff0c\u540c\u65f6\u4e5f\u53ef\u4ee5\u6fc0\u53d1\u81ea\u5df1\u7684\u601d\u8003\uff0c\u800c\u5bf9\u4e8e\u81ea\u5df1\u8bf4\u51fa\u7684\u65b9\u6848\uff0c\u4e5f\u4f1a\u66f4\u613f\u610f\u53bb\u6267\u884c\uff0c\u6700\u7ec8\u4f7f\u547d\u5fc5\u8fbe\u3002 \u201c\u4fc3\u8fdb\u53c2\u4e0e\u201d\u8fd9\u4e2a\u5173\u952e\u884c\u4e3a\uff0c\u8003\u5bdf\u7684\u5c31\u662f\u4e3b\u7ba1\u662f\u5426\u4f1a\u5728\u8f85\u5bfc\u8fc7\u7a0b\u4e2d\u4e3b\u52a8\u8be2\u95ee\u3001\u5bfb\u6c42\u4e0b\u5c5e\u7684\u53c2\u4e0e\u3002  \u8be5\u884c\u4e3a\u548c\u201c\u7ef4\u6301\u52a8\u529b\u201d\u4e00\u6837\uff0c\u4f1a\u8d2f\u7a7f\u4e8e\u6574\u4e2a\u8f85\u5bfc\u8fc7\u7a0b\u7684\u59cb\u7ec8\u3002\u6bd4\u5982\uff0c\u5728\u6f84\u6e05\u5b63\u5b81\u62a5\u544a\u665a\u4ea4\u539f\u56e0\u7684\u65f6\u5019\uff0c\u4ee5\u53ca\u5e2e\u5979\u5bfb\u627e\u548c\u738b\u7ecf\u7406\u6c9f\u901a\u7684\u65b9\u6cd5\u7684\u65f6\u5019\u3002\u90fd\u53ef\u4ee5\u901a\u8fc7\u63d0\u95ee\u6765\u4fc3\u8fdb\u5979\u53c2\u4e0e\uff0c\u5f15\u53d1\u5979\u81ea\u5df1\u601d\u8003\u3002  \u4f60\u5728\u8f85\u5bfc\u4e2d\uff0c\u4f3c\u4e4e\u66f4\u503e\u5411\u4e8e\u76f4\u63a5\u5206\u4eab\uff0c\u800c\u5ffd\u7565\u4e86\u8be2\u95ee\u4e0b\u5c5e\u7684\u610f\u89c1\u3002\u8fd9\u4e5f\u662f\u5f88\u591a\u4e3b\u7ba1\u5728\u8f85\u5bfc\u4e2d\u7684\u201c\u76f2\u533a\u201d\u3002\u6240\u4ee5\uff0c\u5efa\u8bae\u4f60\u4ee5\u540e\u5728\u8f85\u5bfc\u4e2d\uff0c\u591a\u591a\u53d1\u95ee\uff0c\u53bb\u5bfb\u627e\u4e0b\u5c5e\u5de5\u4f5c\u7ed3\u679c\u6b20\u4f73\u6216\u8005\u884c\u4e3a\u4e0d\u826f\u80cc\u540e\u7684\u771f\u6b63\u539f\u56e0\uff1b\u540c\u65f6\u8ba9\u4e0b\u5c5e\u591a\u591a\u53d1\u8868\u81ea\u5df1\u7684\u60f3\u6cd5\uff0c\u601d\u8003\u81ea\u5df1\u600e\u4e48\u53ef\u4ee5\u505a\u4e9b\u4ec0\u4e48\u6765\u6539\u8fdb\u81ea\u5df1  \u7684\u7ee9\u6548\u6216\u8005\u884c\u4e3a\u3002"
  //             }, {
  //                 "name": "\u8fbe\u6210\u5171\u8bc6",
  //                 "value": 1,
  //                 "description": "(\u76f4\u63a5\u6216\u95f4\u63a5)\u901a\u8fc7\u5411\u4e0b\u5c5e\u5206\u4eab\u6539\u8fdb\u5efa\u8bae\u3001\u6700\u4f73\u505a\u6cd5\u3001\u53d1\u5c55\u8d44\u6e90\u3001\u6b63\u9762 \u793a\u8303\u6216\u5efa\u8bae\u5c1d\u8bd5\u65b0\u505a\u6cd5\uff0c\u6765\u8f85\u5bfc\u4e0b\u5c5e\uff1b\u5bf9\u4e0b\u5c5e\u80fd\u6709\u6548\u6267\u884c\u4efb\u52a1\u7684\u52a8\u529b\u548c\u80fd\u529b\uff0c\u8868\u8fbe\u4fe1\u5fc3\u3002",
  //                 "analysis": "\u5728\u4e0b\u5c5e\u9700\u8981\u8d44\u6e90\u652f\u6301\u65f6\uff0c\u4e3b\u52a8\u7ed9\u4e0e\u9002\u5f53\u7684\u652f\u6301\u3002\u5728\u4e0b\u5c5e\u60f3\u65b9\u6848\u65f6\uff0c\u4e3b\u52a8\u5206\u4eab\u4e00\u4e9b\u81ea\u5df1\u7684\u7ecf\u9a8c\uff0c\u7ed9\u51fa\u5efa\u8bae\u548c\u770b\u6cd5\uff0c\u8fd9\u662f\u8f85\u5bfc\u4e2d\u975e\u5e38\u91cd\u8981\u7684\u884c\u4e3a\u3002\u5c24\u5176\u5728\u60f3\u65b9\u6cd5\u3001\u5b9a\u8ba1\u5212\u65f6\uff0c\u201c\u63d0\u4f9b\u652f\u6301\u201d\u5927\u6709\u7528\u6b66\u4e4b\u5730\u3002\u8fd9\u4e2a\u884c\u4e3a\uff0c\u548c \u201c\u4fc3\u8fdb\u53c2\u4e0e\u201d\u76f8\u8f85\u76f8\u6210\u3002\u4e3b\u7ba1\u53ef\u4ee5\u901a\u8fc7\u201c\u95ee\u201d\u548c\u201c\u8bf4\u201d\uff08\u63d0\u4f9b\u652f\u6301\uff09\uff0c\u4e0e\u4e0b\u5c5e\u5171\u540c\u5b8c\u6210\u89e3\u51b3\u65b9\u6848\u3002  \u5728\u672c\u6b21\u8f85\u5bfc\u4e2d\uff0c\u4e3b\u7ba1\u6709\u591a\u6b21\u63d0\u4f9b\u652f\u6301\u7684\u673a\u4f1a\uff0c\u6bd4\u5982\uff1a\u5728\u5b63\u5b81\u77e5\u9053\u600e\u4e48\u505a\u4e86\uff0c\u4f46\u8fd8\u662f\u5bb3\u6015\u548c\u738b\u7ecf\u7406\u6c9f\u901a\u65f6\uff0c\u4e3b\u7ba1\u53ef\u4ee5\u8bf4\u81ea\u5df1\u53ef\u4ee5\u966a\u5979\u4e00\u8d77\u53bb\uff1b\u5728\u5236\u5b9a\u884c\u52a8\u8ba1\u5212\u65f6\uff0c\u4e3b\u52a8\u8bf4\u51fa\u81ea\u5df1\u7684\u65e5\u7a0b\u5b89\u6392\u3002  \u4f60\u5728\u8fd9\u4e2a\u884c\u4e3a\u4e0a\u83b7\u5f97\u4e86\u56db\u661f\u7684\u597d\u6210\u7ee9\uff0c\u606d\u559c\uff01\u4f60\u5728\u672c\u6b21\u8f85\u5bfc\u4e2d\uff0c\u591a\u6b21\u7ed9\u5230\u4e86\u5b63\u5b81\u53ca\u65f6\u7684\u652f\u6301\uff0c\u8bf7\u5728\u5de5\u4f5c\u4e2d\u7ee7\u7eed\u4fdd\u6301\uff0c\u5728\u4e0b\u5c5e\u60f3\u4e0d\u51fa\u65b9\u6848\u7684\u65f6\u5019\uff0c\u7ed9\u4ed6\u5206\u4eab\u4f60\u7684\u7ecf\u9a8c\u548c\u5efa\u8bae\uff0c\u9002\u5f53\u52a0\u4ee5\u5f15\u5bfc\uff1b\u5728\u4e0b\u5c5e\u9700\u8981\u5b9e\u9645\u8d44\u6e90\u652f\u6301\u65f6\uff0c\u4e0d\u541d\u4e8e\u7ed9\u4e0e\u4f60\u7684\u8d44\u6e90"
  //             }, {
  //                 "name": "\u8bbe\u5b9a\u8ba1\u5212",
  //                 "value": 2,
  //                 "description": "\u5f3a\u8c03\u8ba1\u5212\u884c\u52a8\u5bf9\u4e2a\u4eba\u3001\u56e2\u961f\u548c\u7ec4\u7ec7\u7684\u9884\u671f\u6b63\u9762\u5f71\u54cd\uff1b\u786e\u8ba4\u4e2a\u4eba\u5728\u5e94\u5bf9 \u7ee9\u6548\u6311\u6218\u65b9\u9762\u7684\u627f\u8bfa\u548c\u8ba4\u540c\u3002",
  //                 "analysis": "\u201c\u8fbe\u6210\u5171\u8bc6\u201d\u8fd9\u4e2a\u5173\u952e\u884c\u4e3a\u4f1a\u51fa\u73b0\u5728\u8f85\u5bfc\u7684\u6700\u540e\u3002\u5f53\u4f60\u8ddf\u4e0b\u5c5e\u5df2\u7ecf\u5c31\u540e\u7eed\u6539\u8fdb\u7684\u884c\u52a8\u8ba1\u5212\u6709\u4e86\u786e\u5b9a\u7684\u65b9\u6848\u65f6\uff0c\u8fd9\u65f6\u4f1a\u9700\u8981\u4f60\u548c\u4ed6\u786e\u8ba4\u5171\u8bc6\u662f\u5426\u4e00\u81f4\u3002\u4f60\u8981\u505a\u5230\u4e24\u70b9\uff1a\u7b2c\u4e00\uff0c\u4e0b\u5c5e\u8ba4\u540c\u8fd9\u4e2a\u884c\u52a8\u8ba1\u5212\u3002\u7b2c\u4e8c\uff0c\u9f13\u52b1\u4e0b\u5c5e\uff0c\u518d\u6b21\u548c\u4ed6\u5f3a\u8c03\u8fd9\u4e2a\u884c\u52a8\u8ba1\u5212\u5bf9\u4ed6\u4e2a\u4eba\uff0c\u56e2\u961f\u548c\u7ec4\u7ec7\u7684\u6b63\u9762\u5f71\u54cd\u3002  \u5728\u672c\u6b21\u8f85\u5bfc\u4e2d\uff0c\u5728\u548c\u5b63\u5b81\u786e\u8ba4\u4e86\u63a5\u4e0b\u6765\u7684\u884c\u52a8\u8ba1\u5212\u4e4b\u540e\uff0c\u4f60\u8981\u505a\u7684\u5c31\u662f\u4e0e\u5979\u786e\u8ba4\u5979\u5bf9\u8fd9\u4e2a\u884c\u52a8\u8ba1\u5212\u7684\u627f\u8bfa\uff1a\u5979\u613f\u610f\u53bb\u505a\u3002\u540c\u65f6\u8981\u80af\u5b9a\u5979\uff0c\u5f3a\u8c03\u540e\u7eed\u884c\u52a8\u90fd\u505a\u5230\u7684\u8bdd\u5bf9\u5979\u81ea\u5df1\u548c\u56e2\u961f\u7684\u5de5\u4f5c\u90fd\u4f1a\u5927\u6709\u5e2e\u52a9\u3002  \u8f85\u5bfc\u884c\u8fdb\u5230\u5c3e\u58f0\u65f6\uff0c\u5f88\u591a\u7ba1\u7406\u8005\u90fd\u4f1a\u8ba4\u4e3a\u8ba1\u5212\u5df2\u6210\uff0c\u5c31\u53ef\u4ee5\u7ed3\u675f\u4e86\uff0c\u8fd9\u6837\u5f80\u5f80\u4f1a\u529f\u4e8f\u4e00\u7bd1\u3002\u5efa\u8bae\u4f60\u5728\u4ee5\u540e\u7684\u73b0\u5b9e\u8f85\u5bfc\u4e2d\u5c06\u8fd9\u4e24\u70b9\u90fd\u5145\u5206\u5c55\u73b0\uff0c\u8f85\u5bfc\u76ee\u6807\u7684\u8fbe\u6210\u5c06\u4f1a\u66f4\u52a0\u987a\u5229\u3002"
  //             }],
  //             "totalKa": 12
  //         }],
  //         "totalQuizCount": 0,
  //         "allQuizFinished": true,
  //         "finishedQuizCount": 0,
  //         "totalExerciseCount": 2,
  //         "allExerciseFinished": false,
  //         "finishedExerciseCount": 1,
  //         "nextExerciseStartTime": "05\u670804\u65e5\u4e0a\u534808\uff1a00"
  //     }
  // }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-revolution-report/case-practice-revolution-report.component.ts